/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OauthControllerLink$Params {
      body: {

/**
 * 소셜 로그인 시 발급된 연동 토큰
 */
'linkToken': string;
}
}

export function oauthControllerLink(http: HttpClient, rootUrl: string, params: OauthControllerLink$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: {
};
}>> {
  const rb = new RequestBuilder(rootUrl, oauthControllerLink.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      'refreshToken'?: string;
      'user'?: {
      };
      }>;
    })
  );
}

oauthControllerLink.PATH = '/api/oauth/link';
